import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import React, { useState } from "react";
import { Grid, FormControl, InputLabel, Select, Button, TextField } from "@material-ui/core";
import * as icons from "@material-ui/icons";
import testApi from "../../dal/tests";
import ordersApi from "../../dal/orders";
import { gridContainerSpacing } from "../../theme/themes";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { useSnackbar } from "notistack";
import moment from "moment";
import { DatePicker } from "..";
var LookupPatient = function LookupPatient(_ref) {
  var value = _ref.value,
    searchPairTestOf = _ref.searchPairTestOf,
    onChange = _ref.onChange;
  var _useAuth = useAuth0(),
    selectedInstitution = _useAuth.selectedInstitution;
  var _useSnackbar = useSnackbar(),
    enqueueSnackbar = _useSnackbar.enqueueSnackbar;
  var _useState = useState(value && value.patient && value.patient.dateOfBirth),
    _useState2 = _slicedToArray(_useState, 2),
    birthDate = _useState2[0],
    setBirthDate = _useState2[1];
  var _useState3 = useState(value && value.patient ? value.patient.lastName : ""),
    _useState4 = _slicedToArray(_useState3, 2),
    lastName = _useState4[0],
    setLastName = _useState4[1];
  var _useState5 = useState(value && value.patient ? value.patient.firstName : ""),
    _useState6 = _slicedToArray(_useState5, 2),
    firstName = _useState6[0],
    setFirstName = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    searchResults = _useState8[0],
    setSearchResults = _useState8[1];
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    var name = e.target.name;
    switch (name) {
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
    }
  };
  var handleDateChange = function handleDateChange(value) {
    setBirthDate(value);
  };
  var noResultsMessage = function noResultsMessage() {
    enqueueSnackbar("No results found.,", {
      variant: "warning"
    });
  };
  var searchForPatient = function searchForPatient() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var queryList, pairTest, query, ordersSearch;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(selectedInstitution && selectedInstitution.institutionCode && (lastName || firstName || birthDate))) {
                _context.next = 13;
                break;
              }
              queryList = ["?top=100"];
              if (!searchPairTestOf) {
                _context.next = 8;
                break;
              }
              _context.next = 6;
              return testApi.getPairTest(searchPairTestOf);
            case 6:
              pairTest = _context.sent;
              queryList.push("testCode=".concat(pairTest));
            case 8:
              query = queryList.toString().replace(/,/g, "&");
              _context.next = 11;
              return ordersApi.getOrders(selectedInstitution.institutionCode, query);
            case 11:
              ordersSearch = _context.sent;
              filterOrders(ordersSearch.ordersDTO);
            case 13:
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              noResultsMessage();
            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 15]]);
    }));
  };
  var filterOrders = function filterOrders(orders) {
    var filteredList = [];
    filteredList = orders.map(function (order) {
      return {
        patient: order.patient,
        accessionNumber: order.accessionNumber
      };
    });
    lastName && (filteredList = filteredList.filter(function (order) {
      return order.patient && order.patient.lastName && order.patient.lastName.toLowerCase().indexOf(lastName.toLowerCase()) !== -1;
    }));
    firstName && (filteredList = filteredList.filter(function (order) {
      return order.patient && order.patient.firstName && order.patient.firstName.toLowerCase().indexOf(firstName.toLowerCase()) !== -1;
    }));
    birthDate && (filteredList = filteredList.filter(function (order) {
      return order.patient && order.patient.dateOfBirth && moment(order.patient.dateOfBirth).isSame(birthDate);
    }));
    filteredList.sort();
    if ((firstName || lastName || birthDate) && filteredList.length === 0) {
      noResultsMessage();
    }
    setSearchResults(filteredList);
  };
  var setPatient = function setPatient(e) {
    if (!e.target.value) {
      onChange();
      return;
    }
    var patientData = JSON.parse(e.target.value);
    setLastName(patientData.patient.lastName);
    setFirstName(patientData.patient.firstName);
    setBirthDate(patientData.patient.dateOfBirth);
    onChange(patientData);
  };
  return React.createElement(Grid, {
    container: true,
    spacing: gridContainerSpacing
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(TextField, {
    id: "last-name",
    name: "lastName",
    label: "Last Name",
    value: lastName || "",
    onChange: handleChange,
    fullWidth: true
  })), React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(TextField, {
    id: "first-name",
    name: "firstName",
    label: "First Name",
    value: firstName || "",
    onChange: handleChange,
    fullWidth: true
  })), React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(DatePicker, {
    id: "birthdate",
    label: "Birthdate",
    value: birthDate,
    onChange: handleDateChange
  })), React.createElement(Grid, {
    item: true,
    xs: 1
  }, React.createElement(Button, {
    id: "search",
    style: {
      marginTop: "1em"
    },
    onClick: function onClick() {
      return searchForPatient();
    }
  }, React.createElement(icons.Search, null))), searchResults && searchResults.length > 0 && React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(FormControl, {
    fullWidth: true
  }, React.createElement(InputLabel, {
    htmlFor: "select-partner"
  }, "Select Partner"), React.createElement(Select, {
    native: true,
    id: "select-partner",
    name: "selectPartner",
    onChange: setPatient
  }, React.createElement("option", {
    value: ""
  }), searchResults.map(function (result, index) {
    return React.createElement("option", {
      id: "result-".concat(index),
      key: index,
      value: JSON.stringify(result)
    }, result.patient && "".concat(result.patient.lastName ? result.patient.lastName.toUpperCase() + ", " : "").concat(result.patient.firstName ? result.patient.firstName.toUpperCase() : "", " ").concat(moment(result.patient.dateOfBirth).format("l")).concat(result.accessionNumber ? " - Accession#: " + result.accessionNumber : ""));
  })))));
};
export default LookupPatient;